// "Open terminal" for an environment the signed-in user may open a root shell in (D79): one of
// their own personal organisation, or any personal one for a Super Admin. The API decides and
// says why it refuses; this only hides the link where it would be refused.
import { Terminal } from "@phosphor-icons/react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";

import { accessQuery } from "../../auth/access";
import { useT } from "../../i18n";
import { cn } from "../../ui/cn";
import { mayOpenShell } from "./shell";

export function ShellLink({ environmentId, orgId, personal, className }: { environmentId: string; orgId: string; personal: boolean; className?: string }) {
  const t = useT().workloads.environment.shell;
  const me = useQuery(accessQuery());
  if (!mayOpenShell(me.data, orgId, personal)) return null;
  return (
    <Link
      to={`/environments/${environmentId}/terminal`}
      className={cn("inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline", className)}
    >
      <Terminal weight="bold" className="h-4 w-4" /> {t.open}
    </Link>
  );
}
